import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  conektaPaymentAction: null,
};

const wnPaymentsSlice = createSlice({
  name: 'wnPayments',
  initialState,
  reducers: {
    setConektaPaymentAction: (state, action) => {
      state.conektaPaymentAction = action.payload;
    },
    clearConektaPaymentAction: state => {
      state.conektaPaymentAction = null;
    },
  },
});

export const { setConektaPaymentAction, clearConektaPaymentAction } =
  wnPaymentsSlice.actions;

export const WnPaymentsReducer = wnPaymentsSlice.reducer;
